<template>
  <RoleView />
</template>

<script setup>
import RoleView from '@features/workspaces/RoleView.vue';
</script>
